import { tableNewOrder_mok } from "../../data/data-source/order/neworder_mok_data";
import { tableOrderList_mok } from "../../data/data-source/order/OrderList_mok_data";
import { OrderLog_mok } from "../../data/data-source/order/orderLog_mok_data";
import { orderAdd_mok } from "../../data/data-source/order/OrderAdd_mok_data";
import { logorder } from "../../data/data-class/order/orderClass";
import { Neworder } from "../../data/data-class/order/orderClass";
import { Order } from "../../data/data-class/order/orderClass";
import { OrderTable } from "../../data/data-class/order/orderClass";
import { OrderAddTable } from "../../data/data-class/order/orderClass";
class NewOrderRepository {
  static async getNewOrder(text, pageNumber, edit) {
    const neworder = await tableNewOrder_mok.getNewOrder(
      text,
      pageNumber,
      edit
    );
    // console.log(neworder)
    const neworderList = neworder.newOrder.map(
      (order) =>
        new Neworder(
          order.orderNumber,
          order.transactionNumber,
          order.name,
          order.phoneNumber,
          order.city,
          order.status,
          order.id
        )
    );
    const code = neworder.code;

    // console.log(neworderList)
    return {
      neworderList,
      code,
    };
  }
  static async deleteorder(id) {
    const orderid = await tableNewOrder_mok.deleteorder(id);
    const code = orderid.status.code;
    const massage = orderid.status.massage;
    return {
      code,
      massage,
    };
  }
}
class OrderRepository {
  static async getOrder(text, pageNumber, edit) {
    const order_data = await tableOrderList_mok.getOrder(
      text,
      pageNumber,
      edit
    );
    const orderList = order_data.order.map(
      (order) =>
        new Order(
          order.orderNumber,
          order.transactionNumber,
          order.name,
          order.phoneNumber,
          order.city,
          order.status,
          order.id
        )
    );
    const countAll = order_data.countAll;
    return {
      countAll,
      orderList,
    };
  }
  static async deleteorder(id) {
    const orderid = await tableOrderList_mok.deleteorder(id);
    const code = orderid.status.code;
    const massage = orderid.status.massage;
    return {
      code,
      massage,
    };
  }
}
class OrderLogRepository {
  static async getorderLog(editorder) {
    const orderLog_data = await OrderLog_mok.getorderLog(editorder);
    const id = orderLog_data.detail.id;
    const name = orderLog_data.detail.name;
    const status = orderLog_data.detail.status;
    const orderNumber = orderLog_data.detail.orderNumber;
    const orderdate = orderLog_data.detail.orderdate;
    const reciver = orderLog_data.detail.reciver;
    const phoneNumber = orderLog_data.detail.phoneNumber;
    const postalcode = orderLog_data.detail.postalcode;
    const city = orderLog_data.detail.city;
    const address = orderLog_data.detail.address;
    const totalAmount = orderLog_data.detail.totalAmount;
    const paymentMethod = orderLog_data.detail.paymentMethod;
    const transactionNumber = orderLog_data.detail.transactionNumber;
    const Amount = orderLog_data.detail.Amount;
    const deliverycost = orderLog_data.detail.deliverycost;
    const deliverycode = orderLog_data.detail.deliverycode;
    const orderTable = orderLog_data.OrderTable_data.map(
      (order) =>
        new OrderTable(
          order.id,
          order.productName,
          order.number,
          order.amount,
          order.cost
        )
    );

    return {
      id,
      name,
      status,
      orderNumber,
      orderdate,
      reciver,
      phoneNumber,
      postalcode,
      city,
      address,
      totalAmount,
      paymentMethod,
      transactionNumber,
      Amount,
      deliverycost,
      deliverycode,
      orderTable,
    };
  }
  static async deleteorder(id) {
    const orderid = await OrderLog_mok.deleteorder(id);
    const code = orderid.status.code;
    const massage = orderid.status.massage;
    return {
      code,
      massage,
    };
  }
}
class OrderAddRepository {
  //   static async getOrderAdd() {
  //     const orderAdd_data = await orderAdd_mok.getorderAdd();
  //     const Add_table = orderAdd_data.getorderAdd.map(
  //       (order) =>
  //         new OrderAddTable(
  //           order.id,
  //           order.productName,
  //           order.number,
  //           order.amount,
  //           order.cost
  //         )
  //     );
  //     return {
  //       Add_table,
  //     };
  //   }
  static async product(text) {
    const val = await OrderLog_mok.product(text);
    const products = val.products;
    const amount = val.productAmount;
    return {
      products,
      amount,
    };
  }
  static async addorder(order) {
    const order_data = await orderAdd_mok.getorderAdd(order);
    const status = order_data.status.massage;
    const code = order_data.status.code;
    return {
      status,
      code,
    };
  }
}
export { OrderRepository };
export { NewOrderRepository };
export { OrderLogRepository };
export { OrderAddRepository };
